(() => {
  // adds path for pie chart border
  const onlineKey = document.querySelector('#pie-chart-key-online');
  const campusKey = document.querySelector('#pie-chart-key-campus');
  const pieChart = document.querySelector('.js-online-pie-chart svg');
  const onlineHoverCircle = document.querySelector('.js-outer-circle-online');
  const campusHoverCircle = document.querySelector('.js-outer-circle-campus');

  if (!onlineKey || !campusKey) {
    return;
  }

  const isSafari = navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1;
  const onlinePercent = parseInt(onlineKey.dataset.percent, 10);
  const radius = parseInt(document.querySelector('.js-online-segment').getAttribute('r'), 10);
  const onlineRadians = onlinePercent / 15.91549430919;
  const onlineXPos = Math.cos(onlineRadians) * (radius * 2);
  const onlineYPos = isSafari
    ? Math.sin(onlineRadians) * (radius * 2.5)
    : Math.sin(onlineRadians) * (radius * 2);
  pieChart.insertAdjacentHTML('beforeend', `<path class d="m 10 10 l ${onlineXPos} ${onlineYPos}" stroke="#FFFFFF" stroke-width=".15" fill="none"></path>`);

  // highlight key based on hover state
  const highlightKey = (segment, inactiveKey) => {
    segment.addEventListener('mouseenter', () => {
      inactiveKey.classList.add('inactive');
    });
    segment.addEventListener('mouseleave', () => {
      inactiveKey.classList.remove('inactive');
    });
  };

  highlightKey(onlineHoverCircle, campusKey);
  highlightKey(campusHoverCircle, onlineKey);
})();
